// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__GKEJ6","socials":"Footer_socials__2Eydr"};